import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { ModalModule } from 'ngx-bootstrap/modal';
import { MomentModule } from 'ngx-moment';

import { TrapFocusModule } from '®shared/trap-focus';

import { ReviewModule } from '../review.module';

import { ReviewHistoryModalComponent } from './review-history-modal.component';
import { ReviewHistoryEffects } from './review-history.effects';
import { reviewHistoryReducer } from './review-history.reducer';
import {
  STATE_FEATURE_REVIEW_HISTORY,
  getInitialReviewHistoryState,
} from './review-history.state';

@NgModule({
  imports: [
    CommonModule,
    EffectsModule.forFeature([ReviewHistoryEffects]),
    ModalModule,
    MomentModule,
    ReviewModule,
    StoreModule.forFeature(STATE_FEATURE_REVIEW_HISTORY, reviewHistoryReducer, {
      initialState: getInitialReviewHistoryState,
    }),
    TrapFocusModule,
  ],
  declarations: [ReviewHistoryModalComponent],
  exports: [ReviewHistoryModalComponent],
})
export class ReviewHistoryModule {}
